import { ChainId, Currency } from '@noahswap/sdk'
import { BinanceIcon } from '@noahswap/uikit'
import { useMemo } from 'react'
import { WrappedTokenInfo } from '@noahswap/tokens'
import styled from 'styled-components'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import useHttpLocations from '../../hooks/useHttpLocations'
import getTokenLogoURL from '../../utils/getTokenLogoURL'
import Logo from './Logo'

const StyledLogo = styled(Logo)<{ size: string }>`
  width: ${({ size }) => size};
  height: ${({ size }) => size};
  border-radius: 50%;
`

export default function CurrencyLogo({
  currency,
  size = '24px',
  style,
}: {
  currency?: Currency
  size?: string
  style?: React.CSSProperties
}) {
  const { chainId } = useActiveWeb3React()
  let srcs = []
  if (currency?.symbol === 'EOS' || currency?.symbol === 'WEOS') {
    // srcs = [
    //   `https://s3.ap-southeast-1.amazonaws.com/noahark.pro/image/17777-0xc00592aa41d32d137dc480d9f6d0df19b860104f-eos.png`,
    // ]
    srcs = [
      `https://s3.ap-northeast-1.amazonaws.com/1noahark.io/image/17777-0xc00592aa41d32d137dc480d9f6d0df19b860104f-eos.png`,
    ]
    // currency?.symbol === 'BTC' ||
  } else if (currency?.symbol === 'BTC') {
    srcs = ['/images/small-img/btc.svg']
  } else if (currency?.symbol === 'XBTC') {
    srcs = [
      'https://s3.ap-northeast-1.amazonaws.com/1noahark.io/image/7200-0x4aa4365da82acd46e378a6f3c92a863f3e763d34-xbtc.png',
    ]
  } else if (currency?.address && currency?.symbol) {
    // srcs = [
    //   `https://s3.ap-southeast-1.amazonaws.com/noahark.pro/image/${chainId}-${currency?.address.toLowerCase()}-${currency?.symbol.toLowerCase()}.png`,
    // ]
    srcs = [
      `https://s3.ap-northeast-1.amazonaws.com/1noahark.io/image/${chainId}-${currency?.address.toLowerCase()}-${currency?.symbol.toLowerCase()}.png`,
    ]
  }
  return <StyledLogo size={size} srcs={srcs} alt={`${currency?.symbol ?? 'token'} logo`} style={style} />
}
